var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _awaitAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

module.exports = function (readable) {
  // Node.js stream
  if (readable[Symbol.asyncIterator]) return readable; // Browser ReadableStream

  if (readable.getReader) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var reader, _yield$_awaitAsyncGen, done, value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reader = readable.getReader();
              _context.prev = 1;

            case 2:
              if (!true) {
                _context.next = 14;
                break;
              }

              _context.next = 5;
              return _awaitAsyncGenerator(reader.read());

            case 5:
              _yield$_awaitAsyncGen = _context.sent;
              done = _yield$_awaitAsyncGen.done;
              value = _yield$_awaitAsyncGen.value;

              if (!done) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              _context.next = 12;
              return value;

            case 12:
              _context.next = 2;
              break;

            case 14:
              _context.prev = 14;
              reader.releaseLock();
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 14, 17]]);
    }))();
  }

  throw new Error('unknown stream');
};